module.exports = __webpack_public_path__ + "img/logo_title.8901c399.png";